export const createLoadingReducer =
  (resourceActionTypes, initialStates) =>
  (state = initialStates, action) => {
    switch (action.type) {
      case resourceActionTypes.loading:
        return Object.assign({}, state, { loading: true });
      case resourceActionTypes.success:
        return Object.assign(
          {},
          state,
          { loading: false, success: true },
          action.payload
        );
      case resourceActionTypes.failure:
        return Object.assign(
          {},
          state,
          {
            loading: false,
            error: "Unable to process request."
          },
          action.payload
        );
      case resourceActionTypes.reset:
        return Object.assign({}, initialStates);
      default:
        return state;
    }
  };
